<template>
    <div :class="btnClass">
        <slot></slot>
    </div>
</template>

<script>
    import { reactive, toRefs, computed } from 'vue'

    export default {
        name: 'MyButton',
        props: {
            press: { type: Boolean, default: () => false }
        },
        setup: (props, context) => {
            const state = reactive({
                props,
            })

            const btnClass = computed(() => {
                return `button ${props.press ? 'press' : ''}`
            })

            return {
                btnClass,
                ...toRefs(state),
            }
        }
    }
</script>

<style scoped lang="scss">
    .button {
        font-size: 12px;
        padding: 0px;
        margin: 0px;
        text-align: center;
        width: 100px;
        height: 26px;
        line-height: 26px;

        cursor: default;
        /*background-image: url("~@/assets/button_100_26.png");*/
        /*background-repeat: round;*/

        background-color: #fff;
        background-image: url("~@/assets/button/button_lt.png"),url("~@/assets/button/button_rt.png"),url("~@/assets/button/button_lb.png"),url("~@/assets/button/button_rb.png"),url("~@/assets/button/button_h.png"),url("~@/assets/button/button_h.png"),url("~@/assets/button/button_v.png"),url("~@/assets/button/button_v.png");
        background-repeat: no-repeat,no-repeat,no-repeat,no-repeat,repeat-x,repeat-x,repeat-y,repeat-y;
        background-position: left top,right top,left bottom,right bottom,top,bottom,left,right;
    }

    .button:active {
        background-color: #eee;
    }

    .button:active {
        /*background: #aaa;*/
        /*background-image: url("~@/assets/button_100_26.png");*/
        /*background-repeat: round;*/
        transform: translate(1px,1px);
    }

    .press{
        background-color: #eee;
    }

    .btn-style2 {
        width: 60px;
        height: 60px;
        line-height: 60px;
        border-radius: 60px;
        background: radial-gradient(at 0% 30%,#fff 40%, #ccc);
    }
</style>